
import { Quote, Heart } from 'lucide-react';

const FounderStorySection = () => {
  return (
    <section className="container max-w-4xl mx-auto px-4 py-24">
      <div className="text-center mb-16">
        <h2 className="text-5xl md:text-6xl font-black text-white mb-6 tracking-tight">
          Built by someone who
          <span className="block text-yellow-400">finally gets it</span>
        </h2>
        <p className="text-xl text-white/90 font-medium">
          Tired of feeling like a failure? You're not alone.
        </p>
      </div>

      <div className="bg-white/10 backdrop-blur-lg rounded-[3rem] p-12 border border-white/20 shadow-2xl">
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-yellow-400/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Heart className="w-10 h-10 text-yellow-400" />
          </div>
        </div>
        
        <blockquote className="text-xl md:text-2xl text-white/90 leading-relaxed text-center font-medium mb-8">
          "I spent years trying to build 'lasting habits' and feeling like a failure every time I stopped. 
          <br /><br />
          <span className="text-yellow-400 font-bold">Sound familiar?</span>
          <br /><br />
          Then I discovered something life-changing: what if we focused on showing up every day instead of perfect habits? 
          What if we experimented with time-limited commitments instead of forever pressure?
          <br /><br />
          <span className="text-yellow-400 font-bold">Show Up! is for people like us who want to explore life, not perfect it.</span>
          <br /><br />
          Show up every day. Even when it's hard. Especially when it's hard."
        </blockquote>
        
        <div className="text-center">
          <div className="inline-flex items-center gap-4 bg-white/10 rounded-2xl px-8 py-4">
            <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center">
              <span className="text-purple-700 font-black text-lg">👋</span>
            </div>
            <div className="text-left">
              <p className="text-white font-bold">Show Up! Founder</p>
              <p className="text-white/70 text-sm font-medium">Fellow human who struggled with habits</p>
              <p className="text-yellow-400 text-sm font-bold">Now shows up every day (imperfectly)</p>
            </div>
          </div>
        </div>

        {/* Additional emotional connection */}
        <div className="mt-8 bg-yellow-400/10 rounded-2xl p-6 border border-yellow-400/20">
          <p className="text-center text-white/90 font-medium leading-relaxed">
            <span className="font-bold text-yellow-400">"If you've ever felt like you're not 'disciplined enough' or 'motivated enough'</span> 
            <br />
            — this app is for you. Let's show up together, one day at a time."
          </p>
        </div>
      </div>
    </section>
  );
};

export default FounderStorySection;
